import { apiClient, handleApiRequest } from './client'

export type BoardColumnId = 'open' | 'in_progress' | 'waiting' | 'done'

export interface BoardCard {
  key: string
  lane: string
  title: string
  meta: string
  href: string
  count: number | null
  age_days: number | null
  source: string
  column?: BoardColumnId
  expires_at?: string | null
}

export interface BoardLane {
  id: string
  label: string
  columns: Record<BoardColumnId, BoardCard[]>
}

export interface BoardResponse {
  lanes: BoardLane[]
  wip_limit: number
  wip_count: number
  timezone: string
  errors: string[]
  reason?: string | null
}

export const superadminDashboardApi = {
  getBoard: () =>
    handleApiRequest<BoardResponse>(apiClient.get('/api/v1/superadmin/dashboard/board')),
  moveCard: (cardKey: string, column: BoardColumnId) =>
    handleApiRequest<BoardResponse>(
      apiClient.patch(`/api/v1/superadmin/dashboard/board/${encodeURIComponent(cardKey)}`, {
        column,
      }),
    ),
}
